import { render } from "./Navbarcopy.vue?vue&type=template&id=39570891"
import script from "./Navbarcopy.vue?vue&type=script&lang=js"
export * from "./Navbarcopy.vue?vue&type=script&lang=js"

import "./Navbarcopy.vue?vue&type=style&index=0&id=39570891&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__